module.exports = __webpack_public_path__ + "static/media/undraw_portfolio_feedback.2f1ca896.svg";